//import axios from 'axios';
import localforage from 'localforage'
import memoryDriver from 'localforage-memoryStorageDriver'
import { setupCache } from 'axios-cache-adapter';
import axios from 'axios';
import {interceptorResponse, interceptorError} from '@/helpers/interceptorResponse';

class API {
  async configure(){
    const DB_NAME = "infohidro-envresources";
    //await localforage.defineDriver(memoryDriver);

    const forageStore = localforage.createInstance({
      driver: [
        localforage.INDEXEDDB,
        localforage.LOCALSTORAGE,
        memoryDriver._driver
      ],
      name: DB_NAME
    });

    const cache = setupCache({
      // {Number} Maximum time for storing each request in milliseconds,
      // defaults to 15 minutes when using `setup()`.
      maxAge: 24 * 60 * 60 * 1000, // 24 hour
      // {Number} Maximum number of cached request (last in, first out queue system),
      // defaults to `false` for no limit. *Cannot be overridden per request*
      limit: 25,
      store: forageStore,
      // {Function|Boolean} Determine if stale cache should be read when a network error occurs.
      // readOnError: (error) => {
      //   // Attempt reading stale cache data when response status is either 4xx or 5xx
      //   return error.response.status >= 400 && error.response.status < 600
      // },
      // {Boolean} Clear cached item when it is stale.
      // clearOnStale: true,
      // Deactivate `clearOnStale` option so that we can actually read stale cache data
      // By default axios-cache-adapter clears stale cache data automatically, this would conflict with activating the readOnError option, so the clearOnStale option should be set to false.
      // clearOnStale: false,
    });

    const api = axios.create({
      adapter: cache.adapter,
      baseURL: `${process.env.VUE_APP_API_BASE_ENVRESOURCES}`,
      timeout: 60000
    });

    api.interceptors.response.use(
      interceptorResponse,
      interceptorError
    );

    return api;
  }

}

export default API;
